import { render, staticRenderFns } from "./ServiceIntroductionDetail.vue?vue&type=template&id=312f68e5&scoped=true"
import script from "./ServiceIntroductionDetail.vue?vue&type=script&lang=js"
export * from "./ServiceIntroductionDetail.vue?vue&type=script&lang=js"
import style0 from "./ServiceIntroductionDetail.vue?vue&type=style&index=0&id=312f68e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312f68e5",
  null
  
)

export default component.exports